/**
 * Social Media Services Module
 * Exports all social media services and factory functions
 */
// Service exports
export * from './SocialMediaAccountService';
export * from './SocialMediaPostService';
export * from './SocialMediaMetricsService';
export * from './SocialMediaStoryService';
export * from './SocialMediaVideoService';
export * from './SocialMediaAdsService';
export * from './SocialMediaThresholdService';
export * from './SocialMediaDashboardService';
// Service imports for factory
import { SocialMediaAccountService } from './SocialMediaAccountService';
import { SocialMediaPostService } from './SocialMediaPostService';
import { SocialMediaMetricsService } from './SocialMediaMetricsService';
import { SocialMediaStoryService } from './SocialMediaStoryService';
import { SocialMediaVideoService } from './SocialMediaVideoService';
import { SocialMediaAdsService } from './SocialMediaAdsService';
import { SocialMediaThresholdService } from './SocialMediaThresholdService';
import { SocialMediaDashboardService } from './SocialMediaDashboardService';
/**
 * Create all social media services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all social media service instances
 */
export function createSocialMediaServices(http, config) {
    return {
        account: new SocialMediaAccountService(http, config),
        post: new SocialMediaPostService(http, config),
        metrics: new SocialMediaMetricsService(http, config),
        story: new SocialMediaStoryService(http, config),
        video: new SocialMediaVideoService(http, config),
        ads: new SocialMediaAdsService(http, config),
        threshold: new SocialMediaThresholdService(http, config),
        dashboard: new SocialMediaDashboardService(http, config),
    };
}
//# sourceMappingURL=index.js.map